import React from 'react'
import sixo from './sixo.png'
export default function Upcoming() {
  return (
    <div id='Upcoming' className='container' >
      <h3 id="disorder_namer">Upcomming Topics</h3>
      <hr id='disorder_divider'></hr>
      


      <iframe src="https://app.vectary.com/p/46GUGvcZSogcM4BgG6iObC" frameborder="0" width="100%" height="100%" id='last_image'></iframe>
      



      
    </div>
  )
}
